/**
 * FieldHint — small (i) icon next to a form label that, when hovered (desktop)
 * or tapped (mobile), reveals a short explanation popover.
 *
 * Uses Radix Popover so it works on both touch and hover devices.
 *
 * Usage:
 *   <Label className="flex items-center gap-1">
 *     Commissione <FieldHint>Spiegazione del campo...</FieldHint>
 *   </Label>
 */
import React from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export const FieldHint = ({ children, className = "", side = "top" }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Informazioni"
          className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-stone-400 hover:text-[#8A1C2A] hover:bg-stone-100 transition-colors focus:outline-none focus:ring-2 focus:ring-[#8A1C2A]/30 ${className}`}
          onClick={(e) => e.stopPropagation()}
          data-testid="field-hint-trigger"
        >
          <Info className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        sideOffset={6}
        align="start"
        className="max-w-xs text-xs leading-relaxed text-stone-700 bg-white border border-stone-200 shadow-lg p-3 rounded-md z-50"
        data-testid="field-hint-content"
      >
        {children}
      </PopoverContent>
    </Popover>
  );
};

export default FieldHint;
